import type { FC } from 'react'

import { Button } from '@skytech/ui/Button'
import { twMerge } from 'tailwind-merge'

import { Translation } from '@/app/translations/Translation'

type LinkProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  onClick: () => void
  label: string
}
export const LinkComponent: FC<LinkProps> = ({ onClick, label, className, ...props }) => {
  const onClickHandler = (e: React.MouseEvent) => {
    e.stopPropagation()
    onClick()
  }

  return (
    <Button
      onClick={onClickHandler}
      className={twMerge(
        'hover:shadow-basic focus:shadow-basic active:shadow-basic mx-0.5 inline-flex h-8 cursor-pointer items-center justify-center whitespace-nowrap rounded-lg border-none bg-gray-100 px-5 py-0 text-base text-zinc-700 transition ease-out hover:bg-white focus:bg-white active:bg-white',
        className
      )}
      {...props}
    >
      <Translation id={label} />
    </Button>
  )
}
